// extracted by mini-css-extract-plugin
module.exports = {"marginRow":"ContactUs_marginRow__14caN","title":"ContactUs_title__1Pvos","content":"ContactUs_content__2TFpw","backGround":"ContactUs_backGround__oA6_H"};